import { flow, prop, map } from 'lodash/fp';
import { getSelectedFeatures } from 'relient/features';
import isMobile from 'shared/selectors/is-mobile';

export default (state) => ({
  selectedFeatureKeys: flow(prop('feature'), getSelectedFeatures, map(prop('key')))(state),
  language: prop('global.language')(state),
  isMobile: isMobile(state),
});
